import React, {useEffect, useState} from "react";
import ImageUploading from "react-images-uploading";
import {Button, Icon} from "semantic-ui-react";
import DeleteModal from "../../../../components/DeleteModal/DeleteModal";
import {useAppDispatch, useAppSelector} from "../../../../hooks/hooks";
import {
    deletePlayersPhoto,
    updatePlayersPhoto,
    uploadPlayersPhoto
} from "../DartsPlayersCRUD.slice";
import { IUploadPhotoPayload } from "../DartsPlayersCRUD.types";
import './PhotoUploader.scss'

interface IPhotoUploaderProps {
    closeUploaderHandler: (flag: false) => void
    playerId: number
    isPlayerPhoto: string
}

const PhotoUploader: React.FC<IPhotoUploaderProps> = ({closeUploaderHandler, playerId, isPlayerPhoto}) => {
    const dispatch = useAppDispatch()
    const { dartsPlayers } = useAppSelector(state => state.DartsPlayersCRUD)
    const [imageInfo, setImageInfo] = useState(null as any);
    const [imgName, setImgName] = useState('')
    const [imgValue, setImgValue] = useState('')

    useEffect(() => {
        setDefaultPhoto()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setDefaultPhoto = () => {
        const player = dartsPlayers.find(player => player.id === playerId)
        if (isPlayerPhoto && player) {
            const imageList = [
                {
                    dataURL: `data:image/png;base64,${isPlayerPhoto}`,
                    file:new File([],`${player.name} ${player.surname}`)
                }
            ]

            setImageInfo(imageList)
        }
    }

    const onChange = (imageList: any,) => {
        setImageInfo(imageList)

        if (imageList.length !== 0) {
            const WIDTH = 750;
            const HEIGHT = 1000;
            let reader = new FileReader();
            let file = imageList[0].file;
            setImgName(file.name);
            reader.readAsDataURL(file);
            reader.onload = e => {
                let imgUrl: any;
                if (e.target) {
                    imgUrl = e.target.result;
                }
                const img = new Image();
                img.src = imgUrl;

                setImgValue(imgUrl)

                img.onload = (e: any) => {
                    const canvas = document.createElement('canvas');
                    let ratio = WIDTH / e.target.width;

                    if (e.target.height * ratio < HEIGHT) {
                        ratio = HEIGHT / e.target.height
                    }

                    canvas.height = e.target.height * ratio;
                    canvas.width = e.target.width * ratio;
                    const context = canvas.getContext("2d");

                    if (context) {
                        if (canvas.height > HEIGHT) {
                            canvas.height -= canvas.height - HEIGHT;
                        }
                        if (canvas.width > WIDTH) {
                            canvas.width -= canvas.width - WIDTH;
                        }
                        context.drawImage(img, 0, 0, canvas.width, canvas.height);
                        const imgUrl = context.canvas.toDataURL("image/png", 80);

                        setImgValue(imgUrl);
                    }
                };
            }
        }
    };

    const convertImageUrlToFile = (url: string, fileName: string) => {
        const splitImgData = url.split(',');
        if (splitImgData.length < 2) {
            throw new Error('Invalid image data');
        }

        const mimeMatch = splitImgData[0].match(/:(.*?);/);

        if (!mimeMatch || mimeMatch.length < 2) {
            throw new Error('MIME type not found');
        }

        const mime = mimeMatch[1];
        const data = splitImgData[1];

        const dataStr = atob(data);
        let n = dataStr.length;
        const dataArr = new Uint8Array(n);

        while (n--) {
            dataArr[n] = dataStr.charCodeAt(n);
        }

        return new File([dataArr], fileName, {type: mime});
    }

    const onUploadImg = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, uploadFunction: () => void) => {
        event.preventDefault();
        uploadFunction()
    }

    const onClose = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        closeUploaderHandler(false)
    }

    const getTitlePhoto = (imageInfo: any[]) => {
        if (imageInfo.length !== 0) {
            return imageInfo[0].file.name.split('.')[0]
        }
    }


    const onSendPhoto = () => {
        const formData = new FormData();
        formData.append(
            "picture",
            convertImageUrlToFile(imgValue, imgName),
        );
        const payload: IUploadPhotoPayload = {
            id: playerId,
            picture: formData
        }

        closeUploaderHandler(false)
        if (isPlayerPhoto) {
            dispatch(updatePlayersPhoto(payload))
        } else {
            dispatch(uploadPlayersPhoto(payload))
        }
    };

    return (
        <div className="photo-uploader">
            <ImageUploading
                acceptType={["png"]}
                resolutionType={"absolute"}
                onError={((errors) => console.log("errors", errors))}
                value={imageInfo}
                onChange={onChange}>
                {({
                      imageList,
                      onImageUpload,
                      errors

                  }) => (
                    <div className={"photo-uploader__image-wrapper"}>
                        <Icon
                            color="red"
                            name="close"
                            size="large"
                            className="close-icon"
                            onClick={onClose}
                        />
                        {!isPlayerPhoto && !imageList.length && <div className="photo-uploader__btn-wrapper">
                            {
                                <div>
                                    <Button
                                        size="mini"
                                        className="photo-widget-btn"
                                        color="green"
                                        onClick={(e) => onUploadImg(e, onImageUpload)}
                                    >
                                        {imageList.length > 0 ? " Change photo" : "Upload"}
                                    </Button>
                                </div>
                            }
                        </div>}

                        {
                            errors &&
                            <div>
                                {errors.acceptType
                                    &&
                                    <span
                                        className={"upload-error-block"}>Your selected file type is not allow(only png)
                                    </span>}
                                {errors.resolution
                                    &&
                                    <span
                                        className={"upload-error-block"}>Selected file is not match your desired resolution(750x1000)
                                    </span>
                                }
                            </div>
                        }
                        {imageList.map((image, index) => (
                            <div key={index} className="image-item">
                                <h6 className="image-item__title">{getTitlePhoto(imageInfo)}</h6>
                                <div className="downloadable-image-inner">
                                    <img className="downloadable-image" src={image.dataURL} alt={"logo"}/>
                                </div>
                                <div className="image-item__btn-wrapper">
                                    <Button
                                        size="mini"
                                        className="photo-widget-btn"
                                        color="green"
                                        onClick={(e) => onUploadImg(e, onImageUpload)}
                                    >
                                        {imageList.length > 0 ? " Change" : "Upload"}
                                    </Button>
                                    <Button
                                        size="mini"
                                        color="yellow"
                                        onClick={onSendPhoto}
                                    >
                                       Save photo
                                    </Button>
                                    {isPlayerPhoto && <DeleteModal
                                        id={playerId}
                                        btnView={true}
                                        confirmText={
                                            "Are you sure you want to delete photo?"
                                        }
                                        deleteAction={() => dispatch(deletePlayersPhoto({
                                            playerId,
                                            setIsOpenForm: closeUploaderHandler
                                        }))}
                                        titleModal={"Delete  Player's photo"}
                                    />}
                                </div>
                            </div>
                        ))}
                    </div>

                )}
            </ImageUploading>
        </div>
    );
}

export default PhotoUploader





